const DELIVERABLE_EXTENSIONS = [".pptx", ".docx", ".xlsx", ".pdf", ".csv", ".zip"] as const

export type GroupedAssistantFiles = {
  primary: string[]
  secondary: string[]
}

function isB64Sidecar(filename: string): boolean {
  return filename.toLowerCase().endsWith(".b64.txt")
}

function isDeliverable(filename: string): boolean {
  const lower = filename.toLowerCase()
  return DELIVERABLE_EXTENSIONS.some((ext) => lower.endsWith(ext))
}

/**
 * Split assistant-generated files into user-facing deliverables vs intermediate
 * working files. Drops *.b64.txt sidecars entirely. When at least one
 * deliverable extension is present, non-deliverables collapse into secondary;
 * otherwise every visible file stays in primary (preserves code/data flows).
 */
export function groupAssistantFiles(filenames: string[]): GroupedAssistantFiles {
  const visible = filenames.filter((filename) => !isB64Sidecar(filename))
  const deliverables = visible.filter(isDeliverable)

  if (deliverables.length === 0) {
    return { primary: visible, secondary: [] }
  }

  const deliverableSet = new Set(deliverables)
  return {
    primary: deliverables,
    secondary: visible.filter((filename) => !deliverableSet.has(filename)),
  }
}
